export default __webpack_public_path__ + "static/media/pizza-banner-1.2e39792d.png";